import { connect } from 'react-redux'
import { selectors } from '../../../../imports'
import AnimatedCounter from './component'

function mapStateToProps(state, ownProps) {
    const serverStatus = selectors.getServerStatus(state, ownProps.serverId)
    const count = (serverStatus || {}).numPlayers || 0

    return {
        count,
        hide: count < 1,
    }
}

export default connect(mapStateToProps)(AnimatedCounter)



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/components/AnimatedCounter/index.js